var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LazyImage',{staticClass:"mobile-only intro-image",attrs:{"url":require('../../assets/star.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }